import { supabase } from './supabase';

export interface HubSpotSettings {
  portalId: string;
  pipelineId: string;
  pipelineStageId: string;
  hasToken: boolean;
}

export async function fetchHubSpotSettings(coachId: string): Promise<HubSpotSettings | null> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (supabase.rpc as any)('get_hubspot_settings_status', {
    p_coach_id: coachId,
  });

  if (error || !data || data.length === 0) return null;

  const row = data[0] as {
    hubspot_portal_id: string | null;
    hubspot_pipeline_id: string | null;
    hubspot_pipeline_stage_id: string | null;
    has_token: boolean;
  };

  return {
    portalId: row.hubspot_portal_id ?? '',
    pipelineId: row.hubspot_pipeline_id ?? '',
    pipelineStageId: row.hubspot_pipeline_stage_id ?? '',
    hasToken: row.has_token ?? false,
  };
}

export async function saveHubSpotSettings(
  coachId: string,
  settings: {
    portalId: string;
    pipelineId: string;
    pipelineStageId: string;
    accessToken?: string;
  },
): Promise<void> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { error } = await (supabase.from('coaches') as any)
    .update({
      hubspot_portal_id: settings.portalId.trim() || null,
      hubspot_pipeline_id: settings.pipelineId.trim() || null,
      hubspot_pipeline_stage_id: settings.pipelineStageId.trim() || null,
    })
    .eq('id', coachId);

  if (error) throw error;

  const trimmedToken = settings.accessToken?.trim() ?? '';
  if (trimmedToken.length > 0) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { error: rpcError } = await (supabase.rpc as any)('save_hubspot_token', {
      p_coach_id: coachId,
      p_token: trimmedToken,
    });
    if (rpcError) throw rpcError;
  }
}
